<template>
    <div class="content">
        <div class="book-comment">
            <div class="book-comment__overview">
                <div class="book-comment__overview-actions">

                    <!--
                    <base-button :to="`/book/${routeId}/description`" variant="base">
                        <icon-info-round />
                    </base-button>
                    -->

                    <!--
                    <dropdown>
                        <template #content>
                            <ul>
                                <li>
                                    <base-button to="/home">Condividi</base-button>
                                </li>

                                <li>
                                    <base-button to="/home">Scrivi un commento</base-button>
                                </li>
                            </ul>
                        </template>
                    </dropdown>
                    -->
                </div>

                <div class="shell">
                    <div class="book-comment__image">
                        <img :src="pageData.image" :alt="pageData.title">
                    </div>

                    <div class="book-comment__overview-entry">
                        <p>{{pageData.title}}</p>

                        <p class="book-comment__meta">
                            {{pageData.author}} | {{pageData.pages}} pag
                        </p>
                    </div>
                </div>
            </div>

            <div class="book-comment__content">
                <div class="shell">
                    <form-rate-update
                        :comment="review.comment"
                        :rating="review.rating"
                        @on-submit="data => doRating(data)"
                        @on-delete="data => doDelete(data)"
                        @on-cancel="goBack"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, inject, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router'

import BaseButton from '@/components/base-button/base-button';
import Dropdown from '@/components/dropdown/dropdown';
import IconInfoRound from '@/components/icons/icon-info-round/icon-info-round';
import FormRateUpdate from '@/blocks/form-rate-update/form-rate-update';
import {useStore} from "vuex";

export default {
    name: 'BookCommentUpdate',

    components: {
        BaseButton,
        Dropdown,
        IconInfoRound,
        FormRateUpdate
    },

    setup() {
        const toast = inject("toast");        

        const route = useRoute();
        const router = useRouter();
        const store = useStore();        

        const pageData = ref({
            title: '',
            author: '',
            pages: null,
            image: '',
        });

        const review = ref({
            comment: '',
            rating: 0,
        });

        const doRating = data => {
            data.id = route.params.id;
            store.dispatch('bookCommentUpdate', data)
            .then(function(result) {
                toast.success('Recensione modificata!', {
                    position: 'bottom'
                })
                router.push(`/book/${route.params.id}/reviews`)
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        const doDelete = data => {
            data.id = route.params.id;
            store.dispatch('bookCommentDelete', data)
            .then(function(result) {
                toast.success('Recensione eliminata!', {
                    position: 'bottom'
                })
                router.push(`/book/${route.params.id}/reviews`)
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        }

        const goBack = () => {
            router.back()
        }

        onMounted(() => {
            store.dispatch('loadBookReview', route.params.id)
            .then(function(result) {
                const r = result.reviews.data.find(x => x.id === store.getters.profile.id).pivot;

                review.value.comment = r.comment;
                review.value.rating = r.rating;

                pageData.value.title = result.book.title;
                pageData.value.image = cover(result.book);
                pageData.value.description = result.book.description;
                pageData.value.author = authors(result.book);
                pageData.value.pages = result.book.pages;
                pageData.value.rating = result.book.rating;
                pageData.value.readByUsers = result.book.readByUsers;
                pageData.value.readByClasses = result.book.readByClasses;
                pageData.value.reviews = result.book.reviews;
            })
            .catch(function(error) {
                console.log(error)
                toast.error('Si è verificato un errore, riprova più tardi!', {
                    position: 'bottom'
                })
            })
        })     
        
        function cover(book) {
            return book.cdn ? 
                book.cdn : 
                apipath + '/cache/images/book-cover/' + book.id;
        }

        function authors(book) {
            return book.authors.map(function(e) {
                return e.description;
            }).join(',') 
        }

        return {
            pageData,
            review,
            routeId: computed(() => route.params.id),
            doDelete,
            doRating,
            goBack,
            authors,
            cover
        }
    }
}
</script>
